import { Session } from "@/common/models/session";
import { DBSessionThunks } from "@/common/reducers/DBServiceThunks";
import { WaStateStatus } from "../../common/messageServiceInterface";
import store from "../../common/store/extension-store";
import { ContentMessageServiceActions } from "./contentMessageServiceActions";

export class SessionStatusAutomaton {
    private static instance: SessionStatusAutomaton | null = null;

    private currentCalcSession: Session | null = {};
    private previusCalcSession: Session | null = {};
    //private sessionHistoryLog: Session[] = [];
    //private readonly MAX_HISTORY = 50;
    private initialQRCodeTimestamp: number | null = null;


    private readonly RELOAD_IF_WA_DISCONNECTED_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes
    private readonly QR_CODE_TIMEOUT_MS = 4 * 60 * 1000; // 5 minutes
    private readonly LAST_SEEN_THRESHOLD = 5 * 60 * 1000; // 5 minutes
    private waDisconnectCheckTimeout: NodeJS.Timeout | null = null;
    private moreTimeforWaToSyncTrigger: boolean = false;


    private ownerId: string;
    private sessionId: string;
    private localSessionId: string;
    private podId: string;

    private waLogoutTrigger: boolean = false;


    public setSessionContext(ownerId: string, sessionId: string, localSessionId: string, podId: string) {
        this.ownerId = ownerId;
        this.sessionId = sessionId;
        this.localSessionId = localSessionId;
        this.podId = podId;
    }

    public makeSureLocalStorageValuesAreSet() {
        if (!this.sessionId) {
            this.sessionId = window.localStorage.getItem("sessionId") || '';
        }
        if (!this.podId) {
            this.podId = window.localStorage.getItem("podId") || '';
        }
    }

    private restartWaDisconnectCheckSchedule(): void {

        if (this.waDisconnectCheckTimeout) {
            clearTimeout(this.waDisconnectCheckTimeout);
        }

        this.waDisconnectCheckTimeout = setTimeout(() => {

            console.log('[waStateManager] [SessionStatusAutomaton] (restartWaDisconnectCheckSchedule) Reloading page because WhatsApp is disconnected');

            if (this.currentCalcSession?.status !== 'connected') {
                ContentMessageServiceActions.reloadPage(`whatsapp is disconnected for ${this.RELOAD_IF_WA_DISCONNECTED_INTERVAL_MS}ms`);
            }

        }, this.RELOAD_IF_WA_DISCONNECTED_INTERVAL_MS);

    }



    private constructor() {
        this.restartWaDisconnectCheckSchedule();
    }


    public static getInstance(): SessionStatusAutomaton {
        if (!SessionStatusAutomaton.instance) {
            SessionStatusAutomaton.instance = new SessionStatusAutomaton();
        }
        return SessionStatusAutomaton.instance;
    }

    public calcNewState({ state, stream, hasSynced, qrcode }: WaStateStatus, triggerdBy = "", forceUpdate = false): void {

        this.makeSureLocalStorageValuesAreSet();
        // if (this.waLogoutTrigger) {
        //     console.log('[waStateManager] [SessionStatusAutomaton] (calcNewState): waLogoutTrigger: true - skipping');
        //     return
        // }

        // if (!this.sessionId) {
        //     return;
        // }

        console.log(`[waStateManager] [SessionStatusAutomaton] (calcNewState): triggerdBy: ${triggerdBy} | state: ${state} | stream: ${stream} | hasSynced: ${hasSynced} | qrcode: ${qrcode} | sessionId: ${this.sessionId} | forceUpdate: ${forceUpdate}`);

        // this.sessionHistoryLog.push({ ...this.currentCalcSession });
        // if (this.sessionHistoryLog.length > this.MAX_HISTORY) {
        //     this.sessionHistoryLog.shift();
        // }

        // const sessionFromDb = selectCurrentUserSession(store.getState());
        // if (!sessionFromDb?._id) {
        //     return;
        // }

        this.previusCalcSession = { ...this.currentCalcSession };

        this.currentCalcSession = {
            //...sessionFromDb,
            _id: this.sessionId,
            lastSeen: new Date().toISOString(),
            qrcode: '',
            rawWaStatus: { state: state || "", stream: stream || "", hasSynced: hasSynced || false, qrcode: qrcode || "" },
            triggerdBy: triggerdBy || "",
            podId: this.podId,
            options: {
                ignoreOriginalEntity: true,
            }
        };


        if (triggerdBy === "handleLogout") {
            this.currentCalcSession.status = 'logout';
            this.waLogoutTrigger = true;
            ContentMessageServiceActions.triggerWaLogout();

        }


        else if (triggerdBy === "handleQRChanged" && qrcode) {
            //state: 'UNPAIRED', stream: 'DISCONNECTED', hasSynced: undefined
            if (!this.initialQRCodeTimestamp) {
                this.initialQRCodeTimestamp = Date.now();
            }
            console.log('[waStateManager] [SessionStatusAutomaton] (calcNewState): time left to trigger QR timeout :', (1 * 60 * 1000) - (Date.now() - this.initialQRCodeTimestamp));
            if (Date.now() - this.initialQRCodeTimestamp > this.QR_CODE_TIMEOUT_MS) {
                ContentMessageServiceActions.triggerQRTimeout();
            }
            this.currentCalcSession.qrcode = qrcode;
            this.currentCalcSession.status = 'qrcode';
        }


        else if (state === 'CONNECTED' && stream === 'CONNECTED') {
            this.initialQRCodeTimestamp = null;
            this.currentCalcSession.status = 'connected';
            this.currentCalcSession.wasConnected = true;
            this.restartWaDisconnectCheckSchedule();
        }
        else if (state === 'OPENING') {
            this.currentCalcSession.status = 'OPENING';
        }
        else if (state === 'PAIRING') {
            this.currentCalcSession.status = 'PAIRING';
        }
        else if (!hasSynced && state === 'CONNECTED' && stream === 'DISCONNECTED') {
            console.log('[waStateManager] [SessionStatusAutomaton] (calcNewState): WhatsApp has not synced yet');
            this.initialQRCodeTimestamp = null;
            this.currentCalcSession.status = 'syncing';
            this.restartWaDisconnectCheckSchedule();

        }
        else {
            console.log('[waStateManager] [SessionStatusAutomaton] (calcNewState): unrelevant state:', state, stream, hasSynced, qrcode);
            return;
        }

        this.updateSessionStatus(this.currentCalcSession, forceUpdate);
    }


    private updateSessionStatus(session: Session, forceUpdate: boolean): void {

        //const sessionFromDb = selectCurrentUserSession(store.getState());
        // if its local - it will not have a session from db - therefore it will not do anything
        if (!session?._id) {
            console.log('[waStateManager] [SessionStatusAutomaton] (updateSessionStatus) Session ID not found, not updating');
            return;
        }

        if (!this.isDifferent(this.previusCalcSession, session) && !forceUpdate) {
            console.log('[waStateManager] [SessionStatusAutomaton] (updateSessionStatus) No difference detected and forceUpdate is false, not updating');
            return;
        }

        console.log('[waStateManager] [SessionStatusAutomaton] (updateSessionStatus) Updating session status. ForceUpdate:', forceUpdate);
        store.dispatch(DBSessionThunks.patch({
            entity: session,
        }));

    }



    private isDifferent(sessionFromDb: Session, currentCalcSession: Session): boolean {
        console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) Comparing session states');

        if (!sessionFromDb.rawWaStatus || !sessionFromDb.lastSeen || !currentCalcSession.lastSeen) {
            console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) Missing required fields, returning true');
            return true;
        }

        if (sessionFromDb.status !== currentCalcSession.status) {
            console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) Status changed from', sessionFromDb.status, 'to', currentCalcSession.status);
            return true;
        }
        
        if (sessionFromDb.rawWaStatus.stream !== currentCalcSession.rawWaStatus.stream) {
            console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) Stream changed from', sessionFromDb.rawWaStatus.stream, 'to', currentCalcSession.rawWaStatus.stream);
            return true;
        }
        
        if (sessionFromDb.rawWaStatus.hasSynced !== currentCalcSession.rawWaStatus.hasSynced) {
            console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) hasSynced changed from', sessionFromDb.rawWaStatus.hasSynced, 'to', currentCalcSession.rawWaStatus.hasSynced);
            return true;
        }
        
        if (sessionFromDb.rawWaStatus.qrcode !== currentCalcSession.rawWaStatus.qrcode) {
            console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) QR code changed');
            return true;
        }

        // Convert string timestamps to Date objects for comparison
        const sessionFromDbLastSeenDate = new Date(sessionFromDb.lastSeen);
        const currentCalcSessionLastSeenDate = new Date(currentCalcSession.lastSeen);

        if (currentCalcSessionLastSeenDate.getTime() - sessionFromDbLastSeenDate.getTime() > this.LAST_SEEN_THRESHOLD) {
            console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) Last seen time difference exceeds threshold');
            return true;
        }

        console.log('[waStateManager] [SessionStatusAutomaton] (isDifferent) No differences found');
        return false;
    }


    public getWaStatus(): string {
        return this.currentCalcSession?.status || "";
    }


}